import React, { useState } from 'react';
import { format, parse, isValid } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const parseYmd = (s) => {
  if (!s) return undefined;
  const d = parse(String(s).slice(0, 10), 'yyyy-MM-dd', new Date());
  return isValid(d) ? d : undefined;
};

// Drop-in shadcn replacement for <input type="date">.
// Same contract: value is a 'YYYY-MM-DD' string, onChange gets { target: { value } }.
export default function DateInput({ value, onChange, disabled, className = '', placeholder = 'Pick a date', ...rest }) {
  const [open, setOpen] = useState(false);
  const selected = parseYmd(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled}
                className={`input flex items-center justify-between gap-2 text-left font-normal disabled:opacity-60 disabled:cursor-not-allowed ${selected ? '' : 'text-fg-muted'} ${className}`}
                {...rest}>
          <span className="truncate">{selected ? format(selected, 'd MMM yyyy') : placeholder}</span>
          <CalendarIcon className="w-4 h-4 opacity-50 shrink-0"/>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[70]" align="start">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          captionLayout="dropdown-buttons"
          fromYear={1920}
          toYear={new Date().getFullYear() + 10}
          onSelect={(d) => { onChange?.({ target: { value: d ? format(d, 'yyyy-MM-dd') : '' } }); setOpen(false); }}
          classNames={{
            caption_dropdowns: 'flex items-center gap-2',
            caption_label: 'text-sm font-medium flex items-center gap-1',
            dropdown_month: 'relative',
            dropdown_year: 'relative',
            dropdown: 'absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10',
            dropdown_icon: 'w-3 h-3 opacity-60',
            vhidden: 'sr-only',
            day_today: 'bg-[#C89B3C]/20 text-fg font-semibold',
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
